import axios from '../config';
import pureAxios from 'axios';

export const getPresignedUrl = (extentions) => {
   return axios.patch(
      `/presign_url`,
      { ext: extentions },
      {
         headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
         },
      }
   );
};

export const uploadImageToS3 = (url, arrayBuffer) => {
   return pureAxios.put(url, arrayBuffer);
};
